/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Care_Log_PesticidesInputs */

const vi_trace_care_log_pesticides = /** @type {(inputs: Trace_Care_Log_PesticidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thuốc BVTV`)
};

/**

* @param {Trace_Care_Log_PesticidesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_care_log_pesticides = /** @type {((inputs?: Trace_Care_Log_PesticidesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Care_Log_PesticidesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_care_log_pesticides(inputs)
});